import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

type Props = {
	className?: string;
	children: React.ReactNode;
	handleClick?: () => void;
	isSelecting: boolean;
};

export const EditorMenuItemButton = memo(({ className, children, handleClick, isSelecting }: Props) => {
	return (
		<button
			onClick={handleClick}
			className={cn(
				"grid h-12 w-12 place-content-center hover:bg-zinc-100", //
				className,
				isSelecting && "text-brand",
			)}
		>
			{children}
		</button>
	);
});
